import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InvalidNipWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.client.validation.tax-identification-number.nip');
    }
}
